<template>
  <v-card :class="['w-full pa-2 mb-4', { 'bg-highlight': isPeriodActive }]">
    <div class="d-flex flex-row justify-between" style="place-items: center;">
      <div>
        <span class="f-bold f-s-xs" style="color: #000;">{{ itemFF.fare_name }}</span>
      </div>
      <div class="d-flex flex-column" style="font-size: x-small;">
        <span>{{ $t("PurchaseDate") }}</span>
        <span>{{ itemFF.success_time }}</span>
      </div>
    </div>
    <hr :class="[{'hr-highlight': isPeriodActive}]"/>

    <div class="d-flex flex-column my-2">
      <div class="d-flex flex-row f-s-xs">
        <span class="f-bold">{{ $t("TotalTrip") }} :</span>
        <div style="width: 3px;">&nbsp;</div>
        <span v-if="$i18n.locale == 'vi' && itemFF.max_trip == ''" class="f-s-xs">Chuyến đi không giới hạn</span>
        <span v-else-if="$i18n.locale == 'en' && itemFF.max_trip == ''" class="f-s-xs">Unlimited Trips</span>
        <span v-else-if="$i18n.locale == 'vi' && itemFF.max_trip != ''" class="f-s-xs">Tập {{ itemFF.max_trip }} vé</span>
        <span v-else class="f-s-xs">{{ $t("TripTimes").replace("[trip]", itemFF.max_trip) }}</span>
      </div>

      <div class="d-flex flex-row f-s-xs">
        <span class="f-bold">{{ $t("ExpiredDate") }} :</span>
        <div style="width: 3px;">&nbsp;</div>
        <span>{{ formattedExpTicket }}</span>
      </div>
    </div>
    <hr :class="[{'hr-highlight': isPeriodActive}]"/>

    <div class="d-flex flex-row justify-between" style="align-items: center;">
      <div>
        <div v-if="itemFF.last_used != undefined && itemFF.last_used != ''" 
          class="d-flex flex-row mt-2"
        >
          <img
            :src="require('@/assets/new-ui/success.png')"
            style="width: 40px;"
          />
          <div class="d-flex flex-column self-center ml-2"
            style="font-size: x-small;"
          >
            <span class="f-bold f-s-xs">{{ $t("TicketStatus") }}:</span>
            <span style="font-size: 11px;">{{ $t("OneTripActiveUntil").replace("[until]", validPeriod) }}</span>
          </div>
        </div>
        <div v-else 
          class="d-flex flex-column self-center mt-2" style="line-height: 1;">
          <span class="f-bold f-s-xs">{{ $t("TicketStatus") }}:</span>
          <span v-if="isExpired" style="font-size: 11px;">{{ $t("Expired") }}</span>
          <span v-else style="font-size: 11px;">{{ $t("TicketNotYetUsed") }}</span>
          <span style="font-size: 11px;">
            {{ $t("TicketsRemaining") }}
            {{ itemFF.max_trip - itemFF.used_ticket }}
            {{ $t("TicketsRemainingDetail") }}
          </span>
        </div>
      </div>

      <div style="justify-items: flex-end;">
        <v-col class="d-flex justify-center pa-0">
          <div style="height: 40px; align-content: center;">
            <ac-button 
              :small="true"
              :name="$t('ViewTicket')" 
              :on-click-handler="clickView"
              :width="'100px'"
              :height="'35px'"
              :color="$partnerACL.getButtonColor()"
              class="btn-view-ticket"
            />
          </div>
        </v-col>
      </div>
    </div>

    <div v-if="typeof itemFF.ticket_id != 'string'">
      <hr />
      <span class="f-s-xs">{{ $t("TotalBundling") }} : {{ itemFF.ticket_id.length }} {{ $t("Person") }}</span>
    </div>
  </v-card>
</template>

<script>
import AcButton from "@/components/AcButton";
import moment from "moment"

export default {
  name: "CardTicketMultiTrip",
  components: {
    AcButton
  },
  props: {
    itemFF: {
      type: Object,
    },
    tickettransaction: {
      type: String,
      default: "Ticket Transaction",
    },
    orig: {
      type: String,
      default: "BTH",
    },
    original: {
      type: String,
      default: "Bến Thành",
    },
    expticket: {
      type: String,
      default: "Single Trip ticket is valid until 24 hours",
    },
    routename: {
      type: String,
      default: "Route 3",
    },
    flatefare: {
      type: String,
      default: "Single Trip",
    },
    dest: {
      type: String,
      default: "TLC",
    },
    destination: {
      type: String,
      default: "Thạnh Lộc",
    },
    viewticket: {
      type: String,
      default: "ViewTicket",
    },
    routeInformation: {
      type: Object
    },
    isPeriodActive: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    const payloadCurrency = {
      currencyCode: localStorage.getItem('currency') || "IDR",
    };
    await this.$store.dispatch("purchaseticket/getCurrencyConversionRate", payloadCurrency)
  },
  computed: {
    provider() {
      return this.$store.state.auth.provider;
    },
    validPeriod() {
      const time = moment(this.itemFF.last_used);
      const newTime = time.add(this.$partnerACL.getTimePeriod(), 'minutes');
      return newTime.utc().format('DD-MM-YYYY | HH:mm')
    },
    expiredTicket() {
      const DEFAULT_TIME = '23:59:59';
      const now = moment();
      const { validate_close_date, validate_close_time, invoice_detail, valid_days, expired_on_same_day } = this.itemFF

      const closeDate = validate_close_date ? moment(validate_close_date) : null;
      const closeTime = validate_close_time || DEFAULT_TIME;
      const createdDate = moment(invoice_detail[0].payment_success_time);
      const validDaysMoment = moment(now).add(valid_days > 0 ? valid_days - 1 : 0, 'days');

      if (expired_on_same_day) {
        return moment.utc(createdDate.format('YYYY-MM-DD') + ' ' + DEFAULT_TIME)
      }

      // format close datetime
      const fullCloseDate = closeDate
        ? moment(closeDate.format('YYYY-MM-DD') + ' ' + closeTime)
        : null;

      const fallback = moment.utc(createdDate).add(valid_days - 1, 'days').set({
        hour: 23,
        minute: 59,
        second: 59
      })

      if (valid_days > 0) {
        return fallback
      }

      // 1. jika current > closeDate
      if (fullCloseDate && validDaysMoment.isAfter(fullCloseDate)) {
        return moment.utc(fullCloseDate)
      }

      // 2. jika current < closeDate
      if (fullCloseDate && validDaysMoment.isBefore(fullCloseDate)) {
        return moment(validDaysMoment.format('YYYY-MM-DD') + ' ' + closeTime)
      }

      // fallback: createdDate + validDays + default time
      return fallback
    },
    formattedExpTicket() {
      return this.expiredTicket.format("DD-MM-YYYY | HH:mm");
    },
    isExpired() {
      return moment().isAfter(moment(this.expiredTicket))
    }
  },
  methods: {
    clickRouteInformation() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", this.routeInformation);
    },
    clickView() {
      if (this.provider == "GOBUS") {
        this.$router.push({
          name: "GobusDetailTicket",
          params: {
            data: this.itemFF,
          },
        });
      } else {
        const fareType = this.itemFF.fare_type
        const detailButton = this.$partnerACL.getMetaButton('detail');
        if (detailButton) {
          if (detailButton.menu_type == "wsc_menu") {
            let data = this.itemFF
            if (detailButton.redirect_name === "ShowQR") {
              data = this.itemFF.ticket_id
            }
            this.$router.push({
              name: detailButton.redirect_name,
              params: {
                data,
                detail: this.itemFF,
                expired_ticket: this.formattedExpTicket,
                method: (fareType == 9 || fareType == 10) ? "all": "" ,
                is_expired: this.isExpired
              },
            });
          } else {
            window.location = detailButton.redirect_path;
          }
        } else {
          this.$router.push({
            name: "ViewTicket",
            params: {
              data: this.itemFF,
            },
          });
        }
      }
    },
    convertPriceByCurrency(price, currency) {
      const conversionRates = this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.conversionRates : null;
      const priceResult = price * conversionRates[currency];
      return priceResult;
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}

.bg-highlight {
  background-color: #f3fff5;
  border: 1px solid #2bc257;
}

.hr-highlight {
  background-color: #2bc257;
}

.btn-view-ticket {
  font-size: 14px;
}
</style>